import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["tag", "children"];
export var useLink = function useLink(_ref, ref) {
  var _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return {
    rootProps: restProps,
    Tag: Tag,
    tagProps: {
      ref: ref
    },
    children: children
  };
};